import * as yup from 'yup';
import moment from 'moment';

function validateDate(input) {
    try {
        const validatingDate = moment(new Date(input));
        return validatingDate.isValid();
        // eslint-disable-next-line
    } catch (e) {}
    return false;
}

export const vitalImagingLabSchema = yup.object({
    result: yup.string().max(255),
    date: yup.string().nullable().test('Date', 'Must Enter A Date Like MM/DD/YYYY', validateDate),
    range: yup.string().max(255)
});

export function defaultImagingRow() {
    return {
        result: '',
        date: null,
        range: ''
    };
}

export const BARRIERS_AND_OBSTACLES_CONFIG = [
    {
        type: 'checkbox',
        label: 'Does not accept diagnosis'
    },
    {
        type: 'checkbox',
        label: 'Lack of disease state education'
    },
    {
        type: 'checkbox',
        label: 'Does not feel symptoms'
    },
    {
        type: 'checkbox',
        label: 'Poor eating habits'
    },
    {
        type: 'checkbox',
        label: 'Cost of medications and healthcare'
    },
    {
        type: 'checkbox',
        label: 'Transportation Issues'
    },
    {
        type: 'checkbox',
        label: 'Access to healthy foods and resources'
    },
    {
        type: 'checkbox',
        label: 'Previous negative family health experience'
    },
    {
        type: 'checkbox',
        label: 'Vertical communication between provider and patient'
    },
    {
        type: 'checkbox',
        label: 'Additional health conditions'
    },
    {
        type: 'checkbox',
        label: 'Not seeing progress or change'
    },
    {
        type: 'checkbox',
        label: 'Taking care of other family members'
    },
    {
        type: 'checkbox',
        label: 'Difficulty keeping track of multiple medications'
    },
    {
        type: 'checkbox',
        label: 'No barriers or health obstacles identified'
    },
    {
        type: 'checkbox-input',
        label: ''
    }
];

export const PREVENTATIVE_SCREENING_CONFIG = [
    {
        label: 'Annual Wellness Visit (annually)'
    },
    {
        label: 'Colonoscopy (every 10 years)'
    },
    {
        label: 'Retinal Exam / Glaucoma Screening (every 2 years)'
    },
    {
        label: 'Cholesterol Screening (every 5 years)'
    },
    {
        label: 'Mammogram (female only, annually)'
    },
    {
        label: 'Chest X-Ray (annually, high risk only)'
    },
    {
        label: 'Pulmonary Function Test (once per lifetime)'
    },
    {
        label: 'Digital Rectal Exam (prostate, annually)'
    },
    {
        label: 'PSA Test (male only, annually)'
    },
    {
        label: 'Abdominal Aortic Screening (once per lifetime)'
    },
    {
        label: 'Fecal Occult Blood Test (annually)'
    },
    {
        label: 'Bladder Control (annually)'
    },
    {
        label: 'Immunization Screening (per CDC)'
    }
];

export const TOPICS_FOR_INSTRUCTION = [
    {
        type: 'checkbox',
        label: 'Sign/symptoms management and when to notify RN/Therapist or physician and when emergency care is needed'
    },
    {
        type: 'checkbox',
        label: 'Condition/symptom/disease management'
    },
    {
        type: 'checkbox',
        label: 'Blood pressure - self-monitoring'
    },
    {
        type: 'checkbox',
        label: 'Weight monitoring'
    },
    {
        type: 'checkbox',
        label: 'Edema monitoring and management, skin care and wound prevention'
    },
    {
        type: 'checkbox',
        label: 'Causes/manifestions of anxiety and measures to decrease it'
    },
    {
        type: 'checkbox',
        label: 'Medication management, effectiveness, purpose, side effects, new/changed medication'
    },
    {
        type: 'checkbox',
        label: 'Emergency/safety and fall prevention measures'
    },
    {
        type: 'checkbox',
        label: 'Activity targets'
    },
    {
        type: 'checkbox-input',
        label: ''
    }
];

export const OVERALL_TREATMENT_PLAN_SUMMARY = [
    {
        type: 'checkbox',
        label: 'Patient will demonstrate intact skin surface, absence of S/S of skin breakdown'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate knowledge of disease process, treatment goals (medications, diet, activity, safety) and self-care management'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will verbalize S/S of worsening condition to report to RN / Therapist or Physician or to call 911'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate compliance with treatment plan and incorporate treatment principles into daily routine (diet, activity, treatments, safety, etc)'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will verbalize community resources available and how to contact them'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will verbalize plan for follow-up visits with physician or other services and is empowered to be an active participant in these interactions'
    },
    {
        type: 'checkbox',
        label: 'Patient will demonstrate maintenance of blood glucose levels within normal limits for patient'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate compliance in monitoring blood glucose with accurate technique and frequency'
    },
    {
        type: 'checkbox',
        label: 'Patient will demonstrate knowledge/verbalize medication regimen, symptoms of effectiveness, when to notify physician and has a medication management system in place to assist with compliance, as needed'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate ability to prepare and administer insulin using correct technique'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate compliance with medication schedule with or without the use of compliance aids'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate knowledge and compliance with injury or fall prevention activities'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate compliance with prescribed nutrition/fluid requirements'
    },
    {
        type: 'checkbox',
        label: 'Patient will demonstrate effective symptom/pain control through use of medications or other therapies/treatments'
    },
    {
        type: 'checkbox',
        label: 'Patient will demonstrate improved or maintained nutritional status: weight, BMI, skin turgor, labs, other'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver demonstrates adequate support system to assist with food purchase, preparation, storage and delivery'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate ability to acquire nutritious meals'
    },
    {
        type: 'checkbox',
        label: 'Patient will verbalize effects of lifestyle, diet, exercise, weight and treatment compliance on a healthy heart'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate participation in plan of care and verbalize knowledge and agreement with the plan of care'
    },
    {
        type: 'checkbox',
        label: 'Patient will maintain intact skin surface, or absence of signs and symptoms of new skin breakdown'
    },
    {
        type: 'checkbox',
        label: 'Patient/caregiver will demonstrate knowledge and compliance with wound prevention plan (skin care measures, activity and diet)'
    },
    {
        type: 'checkbox',
        label: 'Patient will maintain optimal level of activity within patients ability'
    },
    {
        type: 'checkbox',
        label: 'Patient will demonstrate that physician follow-up appointment was kept within 7 days of discharge from hospital'
    },
    {
        type: 'checkbox-input',
        label: ''
    }
];

export const VITALS = [
    {
        label: 'Heart Rate'
    },
    {
        label: 'Blood Pressure'
    },
    {
        label: 'Height'
    },
    {
        label: 'Weight'
    },
    {
        label: 'BMI'
    },
    {
        label: 'Pain Scale'
    }
];

export const RECENT_LABS = [
    {
        label: 'LDL'
    },
    {
        label: 'HDL'
    },
    {
        label: 'Triglycerides'
    },
    {
        label: 'Total Cholesterol'
    },
    {
        label: 'GFR'
    },
    {
        label: 'SCr'
    },
    {
        label: 'ALT'
    },
    {
        label: 'AST'
    },
    {
        label: 'HbA1c'
    },
    {
        label: 'Urine albumin/creatine ratio (uACR)'
    }
];

export const IMAGING = [
    {
        label: 'X-Rays'
    },
    {
        label: 'MRI'
    },
    {
        label: 'CT Scan'
    },
    {
        label: 'Ultrasound'
    }
];

export const CARE_COORDINATION_REFERRALS = [
    {
        label: 'Care Management Referral'
    },
    {
        label: 'Behavioral Health Referral'
    },
    {
        label: 'Specialist Referral'
    },
    {
        label: 'Home Health Referral'
    },
    {
        label: 'Nutritional Support Referral'
    },
    {
        label: 'Other Referral'
    }
];

// mirrors the server's Joi max on the reviewed AI summary text
export const CARE_PLAN_SUMMARY_MAX_LENGTH = 5000;

// the api wrappers return the Boom payload on failure; 4xx carries a message
// meant for the user (warning), anything else is an outage (error)
export function isClientErrorStatus(statusCode) {
    return statusCode >= 400 && statusCode < 500;
}

export const SUMMARY_ACTIONS = [
    {
        type: 'checkbox',
        label: 'Medication Reconciliation'
    },
    {
        type: 'checkbox',
        label: 'Medication Adherence Consultation'
    },
    {
        type: 'checkbox',
        label: 'Remote Patient Monitoring'
    },
    {
        type: 'checkbox',
        label: 'Behavioral Health Integration'
    },
    {
        type: 'checkbox',
        label: 'Pain Management Coordination'
    },
    {
        type: 'checkbox',
        label: 'Disease State Management'
    },
    {
        type: 'checkbox',
        label: 'Disease State Education'
    },
    {
        type: 'checkbox',
        label: 'Care Coordination'
    },
    {
        type: 'checkbox',
        label: 'Specialist Coordination'
    },
    {
        type: 'checkbox',
        label: 'Transportation Coordination'
    },
    {
        type: 'checkbox-input',
        label: ''
    }
];
